(() => {
  if (window.nuraleaCollectionEventsReady) return;
  window.nuraleaCollectionEventsReady = true;

  document.addEventListener('click', (event) => {
    const swatch = event.target instanceof Element ? event.target.closest('[data-ncl-swatch]') : null;
    if (!swatch || swatch.disabled) return;

    const card = swatch.closest('[data-ncl-card]');
    if (!card || !card.closest('[data-ncl-section]')) return;

    card.querySelectorAll('[data-ncl-swatch]').forEach((button) => {
      const selected = button === swatch;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });

    if (swatch.dataset.variantUrl) {
      card.querySelectorAll('[data-ncl-product-link]').forEach((link) => {
        link.href = swatch.dataset.variantUrl;
      });
    }

    const price = card.querySelector('[data-ncl-price]');
    const compare = card.querySelector('[data-ncl-compare]');
    const saving = card.querySelector('[data-ncl-save]');
    const savingValue = card.querySelector('[data-ncl-save-value]');
    const soldOut = card.querySelector('[data-ncl-sold-out]');
    const onSale = Boolean(swatch.dataset.comparePrice);

    if (price) {
      price.textContent = swatch.dataset.price || '';
      price.classList.toggle('is-sale', onSale);
      price.setAttribute('aria-label', onSale ? card.dataset.saleLabel : card.dataset.regularLabel);
    }
    if (compare) {
      compare.textContent = swatch.dataset.comparePrice || '';
      compare.hidden = !onSale;
    }
    if (saving) {
      if (savingValue) savingValue.textContent = swatch.dataset.saveAmount || '';
      saving.hidden = !swatch.dataset.saveText;
    }
    if (soldOut) soldOut.hidden = swatch.dataset.available === 'true';

    if (swatch.dataset.imageSrc) {
      let image = card.querySelector('.ncl-card__image');
      if (!image) {
        const imageLink = card.querySelector('.ncl-card__image-link');
        if (!imageLink) return;
        image = document.createElement('img');
        image.className = 'ncl-card__image';
        image.decoding = 'async';
        imageLink.replaceChildren(image);
      }
      image.alt = swatch.dataset.imageAlt || '';
      if (swatch.dataset.imageWidth) image.width = Number(swatch.dataset.imageWidth);
      if (swatch.dataset.imageHeight) image.height = Number(swatch.dataset.imageHeight);
      image.sizes = swatch.dataset.imageSizes || '50vw';
      image.srcset = swatch.dataset.imageSrcset || '';
      image.src = swatch.dataset.imageSrc;
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || select.name !== 'sort_by') return;
    const form = select.closest('form[data-ncl-form]');
    if (form && form.closest('[data-ncl-section]')) form.requestSubmit();
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-ncl-form]')) return;
    if (!form.closest('[data-ncl-section]')) return;
    form.querySelectorAll('input[name="page"]').forEach((input) => {
      input.disabled = true;
    });
    form.querySelectorAll('input[type="number"]').forEach((input) => {
      if (input.value === '') input.disabled = true;
    });
  });
})();
